import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import neutralanterior from '../../images/bodymap/gender-neutral-anterior.webp';
import neutralposterior from '../../images/bodymap/gender-neutral-posterior.webp';

export function BodymapNeutralCarousel() {
    return (
        <Carousel>
            <Carousel.Item>
                <img className="d-block w-100" src={neutralanterior} alt="Gender Neutral Bodymap - Anterior" />
            </Carousel.Item>
            <Carousel.Item>
                <img className="d-block w-100" src={neutralposterior} alt="Gender Neutral Bodymap - Posterior" />
            </Carousel.Item>
        </Carousel>
    );
}

export default BodymapNeutralCarousel;
